// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1LG8L","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2DLHk"};